import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  Link,
  withRouter,
} from 'react-router-dom';
import {
  Button,
  Collapse,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal } from '../actions';
import {
  setSidebarActiveTab,
  setSidebarOpen,
} from '../actions/App';
import {
  clearFilesFilters,
  clearSelectedFilters,
} from '../actions/Files';

import { APIupdateUserSettings } from '../api/User';

import SidebarNavigation from './Sidebar/Navigation';
import SidebarCollection from './Sidebar/Collection';
import SidebarFilters from './Sidebar/Filters';
import SidebarCollectionFilters from './Sidebar/CollectionFilters';
import SidebarAllCollections from './Sidebar/AllCollections';
import SidebarMyCollections from './Sidebar/MyCollections';
import CollectionsTree from './Collections/Tree';
import SidebarSpaceUsage from './SidebarSpaceUsage';
import SidebarOnboardingProgress from './SidebarOnboardingProgress';
import UpgradePlanButton from './UpgradePlanButton';
import Hotspot from './Hotspot';

import {
  isImportModalOpen,
  isNumber,
  slugify,
  uuidPattern,
} from '../helpers';
import {
  getSidebarCurrentRoute,
  isArchive,
  isMobile,
  shouldShowSecondSidebar,
} from '../helpers/App';
import {
  userHasCap,
  userIsAdmin,
  userIsManager,
  userCanSeeLikes,
} from '../helpers/Auth';
import { isAllCollectionsPage } from '../helpers/Collections';
import ItemTypes from '../helpers/DNDItemTypes';
import { addFlashMessage } from '../helpers/FlashMessages';
import {
  defaultLogoUrl,
  defaultShareLogoUrl,
  getSetting,
  getUserSetting,
} from '../helpers/Settings';
import { getCurrentURLParams } from '../helpers/URLParams';
import { upgradeModalIfNeeded } from '../helpers/UpgradePlan';

class Sidebar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      featuredCollectionsOpen: getUserSetting('featured_collections_open'),
      linksOpen: getUserSetting('links_open'),
      collectionsTreeOpen: getUserSetting('collections_tree_open'),
      navigationExpanded: false,
    };

    this.toggle = this.toggle.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.closeSidebar = this.closeSidebar.bind(this);
    this.toggleNavigation = this.toggleNavigation.bind(this);
    this.filtersDisabled = this.filtersDisabled.bind(this);
    this.handleOpenNewCollectionModal = this.handleOpenNewCollectionModal.bind(this);
    this.handleMoveSelectedItems = this.handleMoveSelectedItems.bind(this);
  }

  componentDidMount() {
    const { search, location } = this.props;

    const queryParams = new URLSearchParams(location.search);

    const isMatchingPath = ['/results', '/files', '/collections', '/favorites', '/archive'].some(path => location.pathname === path || location.pathname.startsWith(`${path}/`));

    if (isMatchingPath && (search || queryParams.keys().next().done === false)) {
      this.toggle('2');
    }
  }

  componentDidUpdate(prevProps) {
    const {
      resetFilters,
      location,
      filters,
      collectionFilters,
      profile,
    } = this.props;
    const {
      location: prevLocation,
      filters: prevFilters,
      collectionFilters: prevCollectionFilters,
      profile: prevProfile,
    } = prevProps;
    const { activeTab } = this.state;

    const isSecondSidebarOpen = shouldShowSecondSidebar(location);

    if (
      !isImportModalOpen() && (
        (!prevFilters.search && filters.search) ||
        (!prevCollectionFilters.search && collectionFilters.search) ||
        (prevFilters.search && filters.search && prevFilters.search !== filters.search) ||
        (prevLocation.search !== location.search && location.search.length > 0 &&
          (
            location.pathname === '/results' ||
            location.pathname === '/files' ||
            location.pathname === '/collections' ||
            location.pathname === '/favorites' ||
            location.pathname === '/people' ||
            location.pathname === '/archive/files' ||
            location.pathname === '/archive/collections' ||
            location.pathname.match(`/collections/(${uuidPattern})`)
          )
        ) ||
        (
          prevLocation.pathname !== location.pathname && location.search.length > 0 && (
            location.pathname === '/archive/files' ||
            location.pathname === '/archive/collections'
          )
        )
      )
    ) {
      if (isSecondSidebarOpen) {
        this.toggle('2');
      } else {
        const element = document.querySelector('.filters-switch');
        element.classList.add('animate__animated', 'animate__tada');
        const removeFilterClass = () => {
          element.classList.remove('animate__animated', 'animate__tada');
          element.removeEventListener('animationend', removeFilterClass);
        };
        element.addEventListener('animationend', removeFilterClass);
      }
      return;
    }

    if (prevLocation.pathname !== location.pathname) {
      if (this.filtersDisabled()) {
        resetFilters();
        if (activeTab !== '3') {
          this.toggle('1');
        }
      }

      if (isArchive(location.pathname) && !isArchive(prevLocation.pathname)) {
        this.toggle('1');
      }

      if (!this.isFilesPage() && !this.isSearchResultsPage() && !isAllCollectionsPage()) {
        this.closeSidebar();
      }
    }

    if (
      (!prevProfile && profile) ||
      (prevProfile && profile && prevProfile.uuid !== profile.uuid)
    ) {
      this.setInitialGroupsState();
    }
  }

  getUrlParams() {
    const { location } = this.props;
    return location.pathname.replace(/^[/]+|[/]+$/g, '').split('/');
  }

  setInitialGroupsState() {
    this.setState({
      myAssetsOpen: getUserSetting('my_assets_open'),
      featuredCollectionsOpen: getUserSetting('featured_collections_open'),
      linksOpen: getUserSetting('links_open'),
      collectionsTreeOpen: getUserSetting('collections_tree_open'),
    });
  }

  toggle(tab) {
    const {
      sidebarActiveTab,
      setActiveTab,
    } = this.props;

    if (sidebarActiveTab !== tab) {
      setActiveTab(tab);
    }
  }

  toggleSidebar() {
    const {
      sidebarOpen,
      setOpen,
    } = this.props;

    setOpen(!sidebarOpen);
  }

  closeSidebar() {
    const {
      setActiveTab,
      setOpen,
    } = this.props;
    setOpen(false);
    setActiveTab('1');
  }

  isFilesPage() {
    const params = this.getUrlParams();
    if (params[0] === 'files' || (params[0] === 'archive' && params[1] === 'files') || params[0] === 'favorites') {
      return true;
    }
    if ((params[0] === 'collections' || (params[0] === 'archive' && params[1] === 'collections')) && (params[1] && params[1] !== 'all' && !isNumber(params[1]))) {
      return true;
    }
    if (params[0] === 'groups' || ((params[0] === 'uploads' || params[0] === 'downloads') && params[1])) {
      return true;
    }
    return false;
  }

  isCollectionsPage() {
    const params = this.getUrlParams();
    const collectionId = (params[0] === 'archive' && params[1] === 'collections') ? params[2] : params[1];
    if (
      (params[0] === 'collections' || (params[0] === 'archive' && params[1] === 'collections')) &&
      (!collectionId || isNumber(collectionId) || collectionId === 'all' || collectionId === 'my')
    ) {
      return true;
    }
    return false;
  }

  isSearchResultsPage() {
    const params = this.getUrlParams();
    const collectionId = (params[0] === 'archive' && params[1] === 'results') ? params[2] : params[1];
    if (
      (params[0] === 'results' || (params[0] === 'archive' && params[1] === 'results')) &&
      (!collectionId || isNumber(collectionId) || collectionId === 'all' || collectionId === 'my')
    ) {
      return true;
    }
    return false;
  }

  filtersDisabled() {
    return !(this.isFilesPage() || this.isCollectionsPage() || this.isSearchResultsPage());
  }

  switchGroup(group) {
    const {
      myAssetsOpen,
      featuredCollectionsOpen,
      linksOpen,
      collectionsTreeOpen,
    } = this.state;
    const { profile } = this.props;

    if (group === 'myAssets') {
      this.setState(prevState => ({ myAssetsOpen: !prevState.myAssetsOpen }));
      APIupdateUserSettings(profile.uuid, { my_assets_open: !myAssetsOpen });
    }
    if (group === 'featuredCollections') {
      this.setState(prevState => ({ featuredCollectionsOpen: !prevState.featuredCollectionsOpen }));
      APIupdateUserSettings(profile.uuid, { featured_collections_open: !featuredCollectionsOpen });
    }
    if (group === 'links') {
      this.setState(prevState => ({ linksOpen: !prevState.linksOpen }));
      APIupdateUserSettings(profile.uuid, { links_open: !linksOpen });
    }
    if (group === 'collections_tree') {
      this.setState(prevState => ({ collectionsTreeOpen: !prevState.collectionsTreeOpen }));
      APIupdateUserSettings(profile.uuid, { collections_tree_open: !collectionsTreeOpen });
    }
  }

  handleOpenNewCollectionModal(e) {
    const {
      openNewCollectionModal,
      setOpen,
    } = this.props;

    e.preventDefault();
    openNewCollectionModal();
    setOpen(false);
  }

  handleMoveSelectedItems(targetCollectionUuid, droppedItem) {
    const {
      openMoveItemsModal,
      selectedFiles,
      selectedCollections,
      collection,
    } = this.props;

    const files = selectedFiles.map(sf => (sf.uuid));
    const collections = selectedCollections.map(sc => (sc.uuid));
    if (files.length === 0 && collections.length === 0) {
      if (droppedItem.type === ItemTypes.FILE) {
        files.push(droppedItem.id);
      }
      if (droppedItem.type === ItemTypes.COLLECTION) {
        collections.push(droppedItem.id);
      }
    }

    let parentCollectionUuid = targetCollectionUuid;
    if (parentCollectionUuid === 'all') {
      parentCollectionUuid = null;
    }
    if (parentCollectionUuid === 'my') {
      parentCollectionUuid = '-1';
    }

    openMoveItemsModal({
      targetCollectionUuid: parentCollectionUuid,
      currentCollectionUuid: collection ? collection.uuid : null,
      collections,
      files: (targetCollectionUuid === 'all' || targetCollectionUuid === 'my') ? [] : files,
    });
  }

  renderSidebar(hidden = false) {
    if (this.isCollectionsPage()) {
      return <SidebarCollectionFilters />;
    }

    const type = this.isSearchResultsPage() ? null : 'files';
    return <SidebarFilters type={type} hidden={hidden} />;
  }

  toggleNavigation() {
    this.setState(prevState => ({ navigationExpanded: !prevState.navigationExpanded }));
  }

  render() {
    const {
      featuredCollectionsOpen,
      linksOpen,
      collectionsTreeOpen,
      navigationExpanded,
    } = this.state;
    const {
      intl,
      profile,
      featuredCollections,
      selectedCollections,
      location,
      sidebarOpen,
      sidebarActiveTab,
      setOpen,
    } = this.props;

    const customNavigation = getSetting('custom_navigation').filter(c => c.sidebar);
    const customNavigationTitle = getSetting('sidebar_custom_navigation_title') || intl.formatMessage({ defaultMessage: 'Links' });

    const currentSidebarRoute = getSidebarCurrentRoute(location);

    const secondSidebarOpen = shouldShowSecondSidebar(location);

    if (!profile || !profile.client) {
      return null;
    }

    return (
      <>
        <SidebarNavigation expanded={navigationExpanded} toggleNavigation={this.toggleNavigation} />
        <nav className={classnames('sidebar', { 'second-sidebar-closed': !secondSidebarOpen && !sidebarOpen && !isMobile() })}>
          {(secondSidebarOpen || sidebarOpen || isMobile()) ? (
            <>
              <header className="sidebar-header">
                <Button
                  className="expand-button"
                  color="primary"
                  onClick={(e) => { e.preventDefault(); this.toggleNavigation(); }}
                  aria-label={intl.formatMessage({ defaultMessage: 'Expand navigation' })}
                >
                  {navigationExpanded ? (
                    <i className="far fa-chevron-up" />
                  ) : (
                    <i className="far fa-chevron-down" />
                  )}
                </Button>
                {sidebarActiveTab !== '2' && (
                  <NavbarBrand tag={Link} to="/" className="mr-0">
                    <img src={profile.client.logo_url || defaultLogoUrl} alt={profile.client.name || profile.client.subdomain} className="logo" />
                    <img src={profile.client.share_logo_url || defaultShareLogoUrl} alt={profile.client.name || profile.client.subdomain} className="logo-alt" />
                  </NavbarBrand>
                )}
              </header>

              <div className={classnames('sidebar-nav', { active: sidebarOpen, filters: sidebarActiveTab === '2' })}>
                <TabContent activeTab={sidebarActiveTab} className="nav-tab-content">
                  <TabPane tabId="1" className="tab-start">
                    <Nav tag="div" className="ml-auto nav-main">
                      {(profile.client.is_free && (userIsAdmin() || userIsManager())) && (
                        <NavItem tag="div" className="book-demo-link">
                          <NavLink tag="a" href="https://stockpress.co/demo/" target="_blank">
                            <i className="far fa-calendar" />
                            {intl.formatMessage({ defaultMessage: 'Book a demo' })}
                          </NavLink>
                        </NavItem>
                      )}
                      <div className="sidebar-core-nav">
                        <NavItem
                          tag="div"
                          className={classnames({ active: currentSidebarRoute === 'files' })}
                        >
                          <NavLink
                            tag={Link}
                            to={`${isArchive() ? '/archive' : ''}/files${location.pathname === '/files' ? getCurrentURLParams(location) : ''}`}
                            onClick={() => setOpen(false)}
                          >
                            {getSetting('cs1') ? (
                              <>
                                <i className="far fa-file-image" />
                                {
                                  isArchive() ?
                                    intl.formatMessage({ defaultMessage: 'All Archived Images' }) :
                                    intl.formatMessage({ defaultMessage: 'Recent Images' })
                                }
                              </>
                            ) : (
                              <>
                                <i className="far fa-file" />
                                {
                                  isArchive() ?
                                    intl.formatMessage({ defaultMessage: 'All Archived Files' }) :
                                    intl.formatMessage({ defaultMessage: 'All Files' })
                                }
                              </>
                            )}
                          </NavLink>
                        </NavItem>
                        <SidebarAllCollections
                          id="all"
                          index="all"
                          key="all"
                          selectedCollections={selectedCollections}
                          handleMoveSelectedItems={this.handleMoveSelectedItems}
                          handleOpenNewCollectionModal={this.handleOpenNewCollectionModal}
                          onClick={() => setOpen(false)}
                        />
                        {userHasCap('my_collections') && (
                          <SidebarMyCollections
                            id="my"
                            index="my"
                            key="my"
                            selectedCollections={selectedCollections}
                            handleMoveSelectedItems={this.handleMoveSelectedItems}
                            handleOpenNewCollectionModal={this.handleOpenNewCollectionModal}
                            onClick={() => setOpen(false)}
                          />
                        )}
                        {userCanSeeLikes() && (
                          <NavItem
                            tag="div"
                            className={classnames('nav-item-favorites', { active: currentSidebarRoute === 'favorites' })}
                          >
                            <NavLink
                              tag={Link}
                              to="/favorites"
                              onClick={() => setOpen(false)}
                            >
                              <i className="far fa-star" />
                              {intl.formatMessage({ defaultMessage: 'My Favorites' })}
                            </NavLink>
                          </NavItem>
                        )}
                        {!getSetting('sidebar_hide_people') && (
                          <NavItem
                            tag="div"
                            className={classnames('nav-item-people', { active: currentSidebarRoute === 'people' })}
                          >
                            <NavLink
                              tag={Link}
                              to="/people"
                              onClick={(e) => {
                                upgradeModalIfNeeded('face-recognition', () => setOpen(false), e);
                              }}
                            >
                              <i className="far fa-user-viewfinder" style={{ position: 'relative' }}>
                                <Hotspot id="people-sidebar" />
                              </i>
                              {intl.formatMessage({ defaultMessage: 'People' })}
                              <UpgradePlanButton
                                feature="face-recognition"
                                simple={true}
                              />
                            </NavLink>
                          </NavItem>
                        )}
                        {(userIsAdmin() || userIsManager()) && (
                          <NavItem
                            tag="div"
                            className={classnames('nav-content-portals', { active: currentSidebarRoute === 'pages' })}
                          >
                            <NavLink
                              tag={Link}
                              to="/admin/pages"
                              onClick={() => setOpen(false)}
                            >
                              <i className="far fa-table-layout" />
                              {intl.formatMessage({ defaultMessage: 'Content Portals' })}
                            </NavLink>
                          </NavItem>
                        )}
                      </div>
                      {(!isArchive() && featuredCollections.length > 0) && (
                        <>
                          <a
                            href="#featured-collections"
                            className="nav-label sidebar-featured-collections-label"
                            onClick={(e) => {
                              e.preventDefault();
                              this.switchGroup('featuredCollections');
                            }}
                          >
                            <span>
                              {
                                getSetting('cs1') ?
                                  intl.formatMessage({ defaultMessage: 'Featured' }) :
                                  intl.formatMessage({ defaultMessage: 'Featured Collections' })
                              }
                            </span>
                            {featuredCollectionsOpen ? (
                              <i className="far fa-chevron-up" />
                            ) : (
                              <i className="far fa-chevron-down" />
                            )}
                          </a>
                          <Collapse isOpen={featuredCollectionsOpen} className="featured-collections featured-collections-collapse">
                            {featuredCollections.map(c => (
                              <SidebarCollection
                                id={c.uuid}
                                index={c.uuid}
                                key={c.uuid}
                                collection={c}
                                selectedCollections={selectedCollections}
                                handleMoveSelectedItems={this.handleMoveSelectedItems}
                                onClick={() => setOpen(false)}
                              />
                            ))}
                          </Collapse>
                        </>
                      )}
                      {customNavigation.length > 0 && (
                        <>
                          <a
                            href="#links"
                            className="nav-label sidebar-links-label"
                            onClick={(e) => {
                              e.preventDefault();
                              this.switchGroup('links');
                            }}
                          >
                            <span>{customNavigationTitle}</span>
                            {linksOpen ? (
                              <i className="far fa-chevron-up" />
                            ) : (
                              <i className="far fa-chevron-down" />
                            )}
                          </a>
                          <Collapse isOpen={linksOpen} className="sidebar-links-collapse">
                            {customNavigation.map((nitem, idx) => (
                              <NavItem tag="div" key={`${slugify(nitem.title)}-${idx + 1}`}>
                                {nitem.url.includes('https://') ? (
                                  <NavLink tag="a" href={nitem.url} target="_blank" onClick={() => setOpen(false)}>
                                    <i className={`far ${nitem.icon || 'fa-file'}`} />
                                    {nitem.title}
                                  </NavLink>
                                ) : (
                                  <NavLink tag={Link} to={nitem.url} onClick={() => setOpen(false)}>
                                    <i className={`far ${nitem.icon || 'fa-file'}`} />
                                    {nitem.title}
                                  </NavLink>
                                )}
                              </NavItem>
                            ))}
                          </Collapse>
                        </>
                      )}
                      {(profile && profile.uuid) && (
                        <>
                          <a
                            href="#collections"
                            className="nav-label sidebar-collections-preview-label"
                            onClick={(e) => {
                              e.preventDefault();
                              this.switchGroup('collections_tree');
                            }}
                          >
                            <span>
                              {intl.formatMessage({ defaultMessage: 'Collections Preview' })}
                            </span>
                            {collectionsTreeOpen ? (
                              <i className="far fa-chevron-up" />
                            ) : (
                              <i className="far fa-chevron-down" />
                            )}
                          </a>
                          <Collapse isOpen={collectionsTreeOpen} className="collections-tree-collapse">
                            <CollectionsTree
                              links={true}
                              enableAddNew={false}
                              enableSearch={false}
                              hideMyCollections={true}
                              source="sidebar"
                              bypassMyCollectionsRestriction={true}
                              onTransition={() => setOpen(false)}
                            />
                          </Collapse>
                        </>
                      )}
                    </Nav>
                  </TabPane>
                  {sidebarActiveTab === '2' && (
                    <TabPane tabId="2" className="tab-filters">
                      {this.renderSidebar()}
                    </TabPane>
                  )}
                  {sidebarActiveTab === '3' && (
                    <TabPane tabId="3" className="tab-more">
                      {(userIsAdmin() || userIsManager() || userHasCap('browse_archived_files')) && (
                        <Nav className="ml-auto nav-settings" vertical>
                          {userIsAdmin() && (
                            <NavItem>
                              <NavLink tag={Link} to="/admin/duplicates">
                                <i className="far fa-copy" />
                                {intl.formatMessage({ defaultMessage: 'Duplicates' })}
                              </NavLink>
                            </NavItem>
                          )}
                          {(userIsAdmin() || userIsManager()) && (
                            <NavItem>
                              <NavLink tag={Link} to="/admin/pages">
                                <i className="far fa-table-layout" />
                                {intl.formatMessage({ defaultMessage: 'Content Portals' })}
                              </NavLink>
                            </NavItem>
                          )}
                          {(userIsAdmin() || userHasCap('browse_archived_files')) && (
                            <NavItem>
                              <NavLink tag={Link} to="/archive/files">
                                <i className="far fa-archive" />
                                {intl.formatMessage({ defaultMessage: 'Archive' })}
                              </NavLink>
                            </NavItem>
                          )}
                        </Nav>
                      )}
                      <Nav className="ml-auto nav-settings" vertical>
                        {(
                          (
                            userIsAdmin() ||
                            userHasCap('request_download_files_and_collections')
                          ) &&
                          getSetting('download_requests_enabled')
                        ) && (
                          <NavItem>
                            <NavLink tag={Link} to="/download-requests">
                              <i className="far fa-cart-arrow-down" />
                              {intl.formatMessage({ defaultMessage: 'Download requests' })}
                            </NavLink>
                          </NavItem>
                        )}
                        <NavItem>
                          <NavLink tag={Link} to="/downloads">
                            <i className="far fa-download" />
                            {
                              !userIsAdmin() ?
                                intl.formatMessage({ defaultMessage: 'My Downloads' }) :
                                intl.formatMessage({ defaultMessage: 'Downloads' })
                            }
                          </NavLink>
                        </NavItem>
                        {userHasCap('upload_file') && (
                          <NavItem>
                            <NavLink tag={Link} to="/uploads">
                              <i className="far fa-upload" />
                              {
                                !userIsAdmin() ?
                                  intl.formatMessage({ defaultMessage: 'My Uploads' }) :
                                  intl.formatMessage({ defaultMessage: 'Uploads' })
                              }
                            </NavLink>
                          </NavItem>
                        )}
                        {userHasCap('share') && (
                          <NavItem>
                            <NavLink tag={Link} to="/share-links">
                              <i className="far fa-share-alt" />
                              {
                                !userIsAdmin() ?
                                  intl.formatMessage({ defaultMessage: 'My Share links' }) :
                                  intl.formatMessage({ defaultMessage: 'Share links' })
                              }
                            </NavLink>
                          </NavItem>
                        )}
                        {(userIsAdmin() || userIsManager() || userHasCap('upload_pages')) && (
                          <NavItem>
                            <NavLink tag={Link} to="/admin/upload-pages">
                              <i className="far fa-arrow-up-from-bracket" />
                              {intl.formatMessage({ defaultMessage: 'Guest uploads' })}
                            </NavLink>
                          </NavItem>
                        )}
                        {(getSetting('cs1') && userIsAdmin()) && (
                          <NavItem>
                            <NavLink tag={Link} to="/admin/settings/users">
                              <i className="far fa-users" />
                              {intl.formatMessage({ defaultMessage: 'Users' })}
                            </NavLink>
                          </NavItem>
                        )}
                      </Nav>
                      {(userIsAdmin() || userIsManager() || userHasCap('reports')) && (
                        <Nav className="ml-auto nav-settings" vertical>
                          <NavItem>
                            <NavLink tag={Link} to="/admin/reports">
                              <i className="far fa-file-chart-pie" />
                              {intl.formatMessage({ defaultMessage: 'Reports' })}
                            </NavLink>
                          </NavItem>
                        </Nav>
                      )}
                      {((userIsAdmin() || userIsManager() || userHasCap('ftp')) && getSetting('enable_ftp_importer')) && (
                        <Nav className="ml-auto nav-settings" vertical>
                          <NavItem>
                            <NavLink tag={Link} to="/admin/ftp-accounts">
                              <i className="far fa-server" />
                              {intl.formatMessage({ defaultMessage: 'FTP accounts' })}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink tag={Link} to="/admin/ftp-queue">
                              <i className="far fa-file-arrow-up" />
                              {intl.formatMessage({ defaultMessage: 'FTP queue' })}
                            </NavLink>
                          </NavItem>
                        </Nav>
                      )}
                    </TabPane>
                  )}
                </TabContent>
              </div>

              <SidebarOnboardingProgress />
              <SidebarSpaceUsage />
            </>
          ) : (
            sidebarActiveTab === '2' && (
              this.renderSidebar(true)
            )
          )}
        </nav>
      </>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  filters: state.Files.filters,
  search: state.Search.search,
  searchFields: state.Search.search_fields,
  selectedFilters: state.Files.filters,
  featuredCollections: state.Collections.featuredCollections,
  featuredCollectionsLoading: state.Collections.featuredCollectionsLoading,
  collectionFilters: state.Collections.filters,
  selectedFiles: state.Files.selectedFiles,
  collection: state.Collections.collection,
  selectedCollections: state.Collections.selectedCollections,
  sidebarOpen: state.App.sidebarOpen,
  sidebarActiveTab: state.App.sidebarActiveTab,
  secondSidebarOpen: state.App.secondSidebarOpen,
});

const mapDispatchToProps = (dispatch, props) => ({
  resetFilters: () => {
    dispatch(clearFilesFilters());
    dispatch(clearSelectedFilters());
  },
  openNewCollectionModal: () => {
    const { intl } = props;
    dispatch(showModal('CollectionEditModal', {
      className: 'modal-edit-collection',
      afterCreateCollection: (collection) => {
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'A new Collection has been created' }),
          button: {
            url: `/collections/${collection.uuid}`,
            text: intl.formatMessage({ defaultMessage: 'Open Collection' }),
          },
        });
      },
    }));
  },
  openMoveItemsModal: (params) => {
    dispatch(showModal('MoveItemsModal', {
      className: 'modal-move-items',
      backdrop: false,
      ...params,
    }));
  },
  setActiveTab: (tab) => {
    dispatch(setSidebarActiveTab(tab));
  },
  setOpen: (open) => {
    dispatch(setSidebarOpen(open));
  },
});

Sidebar.propTypes = {
  intl: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  profile: PropTypes.object,
  filters: PropTypes.object.isRequired,
  search: PropTypes.string,
  featuredCollections: PropTypes.array.isRequired,
  collectionFilters: PropTypes.object.isRequired,
  resetFilters: PropTypes.func.isRequired,
  openNewCollectionModal: PropTypes.func.isRequired,
  openMoveItemsModal: PropTypes.func.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  setOpen: PropTypes.func.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  collection: PropTypes.object,
  selectedCollections: PropTypes.array.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  sidebarActiveTab: PropTypes.string.isRequired,
};

Sidebar.defaultProps = {
  profile: null,
  collection: null,
  search: null,
};

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(Sidebar)));
